import { gql } from '@apollo/client/core'
import { RESOURCE_TAG_FRAGMENT } from './ResourceTag'

export const RESOURCE_FRAGMENT = gql`
  ${RESOURCE_TAG_FRAGMENT}

  fragment Resource on Resource {
    id
    date
    body
    tags {
      ...ResourceTag
    }
    gallery
    galleryPaths
    video
  }
`
